import React, { useState } from 'react';
import Services from '../../api/Services';
import { Link } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';

import logo from '../../images/logo.png';
import Fbg from '../../images/footer-bg-s2.jpg';

import Img1 from '../../images/banck/1.png';
import Img2 from '../../images/banck/2.png';
import Img3 from '../../images/banck/3.png';
import Img4 from '../../images/banck/4.png';
import Img5 from '../../images/banck/5.png';
import Img6 from '../../images/banck/6.png';

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const FooterS2 = () => {
  const currentYear = new Date().getFullYear();

  const [formData, setFormData] = useState({
    email: '',
    agree: false,
  });

  const [validator] = useState(new SimpleReactValidator());

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });

    validator.showMessageFor(name);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validator.allValid()) {
      setFormData({ email: '', agree: false });
      validator.hideMessages();
    } else {
      validator.showMessages();
    }
  };

  return (
    <footer className='wpo-site-footer-s2'>
      <div className='wpo-upper-footer'>
        <div className='container'>
          <div className='row'>
            <div className='col col-lg-3 col-md-6 col-sm-12 col-12'>
              <div className='widget address-widget'>
                <div className='widget-title'>
                  <div className='logo'>
                    <img src={logo} alt='Ferry Gold Shipping' />
                  </div>
                </div>
                <p>
                  Ferry Gold Shipping provides reliable road, air, ocean, and
                  warehousing solutions for businesses that need safe and
                  efficient cargo movement.
                </p>
              </div>
            </div>

            <div className='col col-lg-3 col-md-6 col-sm-12 col-12'>
              <div className='widget link-widget'>
                <div className='widget-title'>
                  <h3>Services</h3>
                </div>
                <ul>
                  {Services.slice(0, 4).map((service, item) => (
                    <li key={item}>
                      <Link
                        onClick={ClickHandler}
                        to={`/services/${service.slug}`}
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className='col col-lg-3 col-md-6 col-sm-12 col-12'>
              <div className='widget link-widget'>
                <div className='widget-title'>
                  <h3>Useful Links</h3>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to='/about'>
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to='/services'>
                      Our Services
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to='/tracking'>
                      Tracking
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to='/contact'>
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className='col col-lg-3 col-md-6 col-sm-12 col-12'>
              <div className='widget link-widget'>
                <div className='widget-title'>
                  <h3>Contact</h3>
                </div>
                <ul>
                  <li>
                    Yau Lee Centre, UNIT 78, 3/F, 45 Hoi Yuen Rd, Kwun Tong,
                    Hong Kong
                  </li>
                  <li>info@ferrygoldshipping.com</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='wpo-lower-footer'>
        <div className='container'>
          <div className='row g-0 align-items-center'>
            <div className='col col-12'>
              <p className='copyright'>
                &copy; {currentYear} Ferry Gold Shipping. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className='bg-image'>
        <img src={Fbg} alt='' />
      </div>
      <div className='shape'>
        <svg width='191' height='208' viewBox='0 0 191 208' fill='none'>
          <path
            d='M125.53 208.291H118.13L0 12.271V0.00102234L125.53 208.291Z'
            fill='white'
          />
          <path d='M0 43.1711L99.93 209.121H0V43.1711Z' fill='#B2784A' />
          <path
            d='M190.33 209.121H138.45L68.9102 93.7311H120.79L190.33 209.121Z'
            fill='#B2784A'
          />
          <path
            d='M98.0897 69.1602H72.8097L38.9297 12.9402H64.2097L98.0897 69.1602Z'
            fill='#B2784A'
          />
        </svg>
      </div>
    </footer>
  );
};

export default FooterS2;
